import { useMemo, useState } from "react";
import { SalonReport } from "../../../types/reports";
import {
  groupReportsByCategory,
  ReportCatalog,
  reportDisplayDescription,
  reportDisplayName,
  ReportSection,
} from "./reportCatalog";

/** Show the search field once the list is longer than this. */
export const SIDEBAR_SEARCH_THRESHOLD = 6;

export interface ReportSections {
  query: string;
  setQuery: (query: string) => void;
  /** The list is long enough to offer search. */
  showSearch: boolean;
  /** The (searched) reports by catalog category, Legacy last. */
  sections: ReportSection[];
}

/**
 * The user's report list as the desktop sidebar and the phone list show it:
 * catalog-category sections (Legacy last), searchable by name / description
 * once the list is long.
 */
export function useReportSections(
  reports: SalonReport[],
  catalog: ReportCatalog,
): ReportSections {
  const [query, setQuery] = useState("");
  const showSearch = reports.length > SIDEBAR_SEARCH_THRESHOLD;

  const sections = useMemo(() => {
    const q = showSearch ? query.trim().toLowerCase() : "";
    const visible = q
      ? reports.filter((r) =>
          `${reportDisplayName(r, catalog)} ${reportDisplayDescription(r, catalog)}`
            .toLowerCase()
            .includes(q),
        )
      : reports;
    return groupReportsByCategory(visible, catalog);
  }, [reports, catalog, query, showSearch]);

  return { query, setQuery, showSearch, sections };
}
